<template>
  <div class="newHeader" :class="{newHeader1:homeType}">
    <div v-if="homeType">
      <div class="headerFixed" :style="{left: '-' + leftOffset + 'px'}">
        <div class="box clearfix">
          <div class="headerLogo">
            <router-link to="/"
              ><img src="/static/home/MANA_head_logo@2x.png" alt=""
            /></router-link>
          </div>
          <div class="headerBottom">
            <ul class="navUl clearfix" :class="{ navUlEn: language !== 'zh' }">
              <li :class="{ active: isActive == 1 }">
                <router-link to="/">{{ $t("global.首页") }}</router-link>
              </li>
              <li @mouseenter="isShow14 = true" @mouseleave="isShow14 = false">
                <p>
                  {{ $t("global.发现")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow14">
                  <router-link to="/explorevideo">{{
                    $t("global.视频")
                  }}</router-link>
                  <router-link to="/exploreauth">{{
                    $t("global.创作者")
                  }}</router-link>
                  <router-link to="/article">{{
                    $t("global.文章")
                  }}</router-link>
                  <router-link to="/exploresubject">{{
                    $t("global.频道")
                  }}</router-link>
                  <router-link to="/academy/home">{{
                    $t("global.学院")
                  }}</router-link>
                  <router-link to="/live/list">{{
                    $t("global.直播")
                  }}</router-link>
                </div>
              </li>
              <li :class="{ active: isActive == 2 }">
                <router-link to="/activity/match">{{
                  $t("global.竞赛")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 4 }">
                <router-link to="/channel/1">{{
                  $t("global.高校")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 5 }">
                <router-link to="/activity/all">{{
                  $t("global.活动")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 6 }">
                <router-link to="/jobs/home">{{
                  $t("global.招聘")
                }}</router-link>
              </li>
              <li @mouseenter="isShow9 = true" @mouseleave="isShow9 = false">
                <p>
                  {{ $t("business.合作")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow9">
                  <router-link to="/business">{{
                    $t("business.商务合作")
                  }}</router-link>
                  <router-link to="/service">{{
                    $t("business.产商服务")
                  }}</router-link>
                </div>
              </li>
              <li @mouseenter="isShow10 = true" @mouseleave="isShow10 = false">
                <p>APP</p>
                <div class="appUpload" v-show="isShow10">
                  <img src="/static/home/MANA_App_download_2@2x.png" alt="" />
                </div>
              </li>
            </ul>
          </div>
          <div class="sousuo clearfix" :class="{ sousuoEn: language !== 'zh' }">
            <input
              type="text"
              :placeholder="$t('global.搜索作品、创作者、文章')"
              v-model="searchContent"
              @keyup.enter="searchSubmit"
            />
            <div class="sousuoIcon" @click="searchSubmit">
              <img src="/static/home/head_search_icon@2x.png" alt="" /><span>{{
                $t("global.搜索")
              }}</span>
            </div>
          </div>
          <div class="login" v-if="!login">
            <p>
              <router-link
                :to="`/login?redirecturl=${redirecturl}`"
                tag="span"
                >{{ $t("global.登录") }}</router-link
              >
              /
              <router-link to="/reg" tag="span">{{
                $t("global.注册")
              }}</router-link>
            </p>
          </div>
          <div
            class="submit"
            @mouseenter="isShow11 = true"
            @mouseleave="isShow11 = false"
          >
            <p class="title">
              <img src="/static/home/head_upload_btn@2x.png" alt="" />{{
                $t("global.发布")
              }}
            </p>
            <div class="down" v-show="isShow11">
              <router-link to="/UpVideo"
                ><img src="/static/home/publish_video@2x.png" alt="" />{{
                  $t("global.视频")
                }}</router-link
              >
              <router-link to="/article/edit"
                ><img src="/static/home/publish_article@2x.png" alt="" />{{
                  $t("global.文章")
                }}</router-link
              >
              <router-link to="/activity/all?type=1"
                ><img src="/static/home/publish_event@2x.png" alt="" />{{
                  $t("global.活动")
                }}</router-link
              >
            </div>
          </div>
          <div class="message" v-if="login" @click="gotoMess('/MessageCenter')">
            <img src="/static/home/notification_icon_hover@2x.png" alt="" />
            <span v-show="messageCount !== 0"></span>
          </div>
          <div
            class="avatar"
            v-if="login"
            @mouseenter="isShow12 = true"
            @mouseleave="isShow12 = false"
          >
            <router-link to="/manageCenter">
              <img
                :src="
                  peopleMessage &&
                  peopleMessage.avatar
                    | imageUrl('/static/profile_img_default.png', 72, 72)
                "
              />
            </router-link>

            <div class="down" v-show="isShow12">
              <div class="nameDiv">{{ peopleMessage.nickname }}</div>
              <div class="countDiv">
                <span @click="gotoPeople(1)"
                  >{{ $t("global.关注") }}<i>{{ followCount || 0 }}</i></span
                >
                ·
                <span @click="gotoPeople(2)"
                  >{{ $t("global.粉丝") }}<i>{{ fansCount || 0 }}</i></span
                >
              </div>
              <router-link
                target="_blank"
                :to="`/peopleCenter/${peopleMessage.userId}`"
                class="myHome"
                >{{ $t("global.我的主页") }}</router-link
              >
              <div class="peopleHome">
                <router-link to="/manageVideo" target="_blank">{{
                  $t("global.个人中心")
                }}</router-link>
                <router-link to="/manageVideo">{{
                  $t("global.视频管理")
                }}</router-link>
                <router-link to="/MyCollect">{{
                  $t("global.我的收藏")
                }}</router-link>
                <router-link to="/MyCompetition">{{
                    $t("global.我的竞赛")
                  }}</router-link>
                <router-link to="/MyRecruit" v-if="isAuthentication">{{
                    $t("recruit.招聘管理")
                  }}</router-link>
                  <router-link to="/jobWanted" v-else>{{
                    $t("recruit.求职管理")
                  }}</router-link>
              </div>
              <div class="accountHome">
                <router-link to="/manageCenter">{{
                  $t("global.账户设置")
                }}</router-link>
                <p @click="loginout">{{ $t("global.退出登录") }}</p>
              </div>
            </div>
          </div>
          <div
            class="language"
            @mouseenter="isShow13 = true"
            @mouseleave="isShow13 = false"
          >
            <p class="title">
              <img src="/static/home/lang_icon@2x.png" alt="" />{{
                showLanguage
              }}
            </p>
            <div class="down" v-show="isShow13">
              <p @click="changeLanguage('中文')">中文</p>
              <p @click="changeLanguage('English')">English</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="headerBox clearfix">
        <div class="headerLogo">
          <router-link to="/"
            ><img src="/static/home/MANA_head_logo@2x.png" alt=""
          /></router-link>
        </div>
        <div class="headerContent">
          <div class="headerTop clearfix">
            <div
              class="sousuo clearfix"
              :class="{ sousuoEn: language !== 'zh' }"
            >
              <input
                type="text"
                :placeholder="$t('global.搜索作品、创作者、文章')"
                v-model="searchContent"
                @keyup.enter="searchSubmit"
              />
              <div class="sousuoIcon" @click="searchSubmit">
                <img src="/static/home/head_search_icon@2x.png" alt="" /><span
                  >{{ $t("global.搜索") }}</span
                >
              </div>
            </div>
            <div class="login" v-if="!login">
              <p>
                <router-link
                  :to="`/login?redirecturl=${redirecturl}`"
                  tag="span"
                  >{{ $t("global.登录") }}</router-link
                >
                /
                <router-link to="/reg" tag="span">{{
                  $t("global.注册")
                }}</router-link>
              </p>
            </div>
            <div
              class="submit"
              @mouseenter="isShow6 = true"
              @mouseleave="isShow6 = false"
            >
              <p class="title">
                <img src="/static/home/head_upload_btn@2x.png" alt="" />{{
                  $t("global.发布")
                }}
              </p>
              <div class="down" v-show="isShow6">
                <router-link to="/UpVideo"
                  ><img src="/static/home/publish_video@2x.png" alt="" />{{
                    $t("global.视频")
                  }}</router-link
                >
                <router-link to="/article/edit"
                  ><img src="/static/home/publish_article@2x.png" alt="" />{{
                    $t("global.文章")
                  }}</router-link
                >
                <router-link to="/activity/all?type=1"
                  ><img src="/static/home/publish_event@2x.png" alt="" />{{
                    $t("global.活动")
                  }}</router-link
                >
              </div>
            </div>
            <div
              class="message"
              v-if="login"
              @click="gotoMess('/MessageCenter')"
            >
              <img src="/static/home/notification_icon_hover@2x.png" alt="" />
              <span v-show="messageCount !== 0"></span>
            </div>
            <div
              class="avatar"
              v-if="login"
              @mouseenter="isShow7 = true"
              @mouseleave="isShow7 = false"
            >
              <router-link to="/manageCenter">
                <img
                  :src="
                    peopleMessage &&
                    peopleMessage.avatar
                      | imageUrl('/static/profile_img_default.png', 72, 72)
                  "
                />
              </router-link>

              <div class="down" v-show="isShow7">
                <div class="nameDiv">{{ peopleMessage.nickname }}</div>
                <div class="countDiv">
                  <span @click="gotoPeople(1)"
                    >{{ $t("global.关注") }}<i>{{ followCount || 0 }}</i></span
                  >
                  ·
                  <span @click="gotoPeople(2)"
                    >{{ $t("global.粉丝") }}<i>{{ fansCount || 0 }}</i></span
                  >
                </div>
                <router-link
                  target="_blank"
                  :to="`/peopleCenter/${peopleMessage.userId}`"
                  class="myHome"
                  >{{ $t("global.我的主页") }}</router-link
                >
                <div class="peopleHome">
                  <router-link to="/manageVideo" target="_blank">{{
                    $t("global.个人中心")
                  }}</router-link>
                  <router-link to="/manageVideo">{{
                    $t("global.视频管理")
                  }}</router-link>
                  <router-link to="/MyCollect">{{
                    $t("global.我的收藏")
                  }}</router-link>
                  <router-link to="/MyCompetition">{{
                    $t("global.我的竞赛")
                  }}</router-link>
                  <router-link to="/MyRecruit" v-if="isAuthentication">{{
                    $t("recruit.招聘管理")
                  }}</router-link>
                  <router-link to="/jobWanted" v-else>求职管理</router-link>
                </div>
                <div class="accountHome">
                  <router-link to="/manageCenter">{{
                    $t("global.账户设置")
                  }}</router-link>
                  <p @click="loginout">{{ $t("global.退出登录") }}</p>
                </div>
              </div>
            </div>
            <div
              class="language"
              @mouseenter="isShow5 = true"
              @mouseleave="isShow5 = false"
            >
              <p class="title">
                <img src="/static/home/lang_icon@2x.png" alt="" />{{
                  showLanguage
                }}
              </p>
              <div class="down" v-show="isShow5">
                <p @click="changeLanguage('中文')">中文</p>
                <p @click="changeLanguage('English')">English</p>
              </div>
            </div>
          </div>
          <div class="headerBottom">
            <ul class="navUl clearfix" :class="{ navUlEn: language !== 'zh' }">
              <li :class="{ active: isActive == 1 }">
                <router-link to="/">{{ $t("global.首页") }}</router-link>
              </li>
              <li @mouseenter="isShow1 = true" @mouseleave="isShow1 = false">
                <p>
                  {{ $t("global.发现")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow1">
                  <router-link to="/explorevideo">{{
                    $t("global.视频")
                  }}</router-link>
                  <router-link to="/exploreauth">{{
                    $t("global.创作者")
                  }}</router-link>
                  <router-link to="/article">{{
                    $t("global.文章")
                  }}</router-link>
                  <router-link to="/exploresubject">{{
                    $t("global.频道")
                  }}</router-link>
                  <router-link to="/academy/home">{{
                    $t("global.学院")
                  }}</router-link>
                  <router-link to="/live/list">{{
                    $t("global.直播")
                  }}</router-link>
                </div>
              </li>
              <li :class="{ active: isActive == 2 }">
                <router-link to="/activity/match">{{
                  $t("global.竞赛")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 4 }">
                <router-link to="/channel/1">{{
                  $t("global.高校")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 5 }">
                <router-link to="/activity/all">{{
                  $t("global.活动")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 6 }">
                <router-link to="/jobs/home">{{
                  $t("global.招聘")
                }}</router-link>
              </li>
              <li @mouseenter="isShow3 = true" @mouseleave="isShow3 = false">
                <p>
                  {{ $t("business.合作")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow3">
                  <router-link to="/business">{{
                    $t("business.商务合作")
                  }}</router-link>
                  <router-link to="/service">{{
                    $t("business.产商服务")
                  }}</router-link>
                </div>
              </li>
              <li @mouseenter="isShow4 = true" @mouseleave="isShow4 = false">
                <p>APP</p>
                <div class="appUpload" v-show="isShow4">
                  <img src="/static/home/MANA_App_download_2@2x.png" alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="headerFixed" v-if="isHeaderShow" :style="{left: '-' + leftOffset + 'px'}">
        <div class="box clearfix">
          <div class="headerLogo">
            <router-link to="/"
              ><img src="/static/home/MANA_head_logo@2x.png" alt=""
            /></router-link>
          </div>
          <div class="headerBottom">
            <ul class="navUl clearfix" :class="{ navUlEn: language !== 'zh' }">
              <li :class="{ active: isActive == 1 }">
                <router-link to="/">{{ $t("global.首页") }}</router-link>
              </li>
              <li @mouseenter="isShow14 = true" @mouseleave="isShow14 = false">
                <p>
                  {{ $t("global.发现")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow14">
                  <router-link to="/explorevideo">{{
                    $t("global.视频")
                  }}</router-link>
                  <router-link to="/exploreauth">{{
                    $t("global.创作者")
                  }}</router-link>
                  <router-link to="/article">{{
                    $t("global.文章")
                  }}</router-link>
                  <router-link to="/exploresubject">{{
                    $t("global.频道")
                  }}</router-link>
                  <router-link to="/academy/home">{{
                    $t("global.学院")
                  }}</router-link>
                  <router-link to="/live/list">{{
                    $t("global.直播")
                  }}</router-link>
                </div>
              </li>
              <li :class="{ active: isActive == 2 }">
                <router-link to="/activity/match">{{
                  $t("global.竞赛")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 4 }">
                <router-link to="/channel/1">{{
                  $t("global.高校")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 5 }">
                <router-link to="/activity/all">{{
                  $t("global.活动")
                }}</router-link>
              </li>
              <li :class="{ active: isActive == 6 }">
                <router-link to="/jobs/home">{{
                  $t("global.招聘")
                }}</router-link>
              </li>
              <li @mouseenter="isShow9 = true" @mouseleave="isShow9 = false">
                <p>
                  {{ $t("business.合作")
                  }}<img src="/static/home/head_more_tri@2x.png" alt="" />
                </p>
                <div class="down" v-show="isShow9">
                  <router-link to="/business">{{
                    $t("business.商务合作")
                  }}</router-link>
                  <router-link to="/service">{{
                    $t("business.产商服务")
                  }}</router-link>
                </div>
              </li>
              <li @mouseenter="isShow10 = true" @mouseleave="isShow10 = false">
                <p>APP</p>
                <div class="appUpload" v-show="isShow10">
                  <img src="/static/home/MANA_App_download_2@2x.png" alt="" />
                </div>
              </li>
            </ul>
          </div>
          <div class="sousuo clearfix" :class="{ sousuoEn: language !== 'zh' }">
            <input
              type="text"
              :placeholder="$t('global.搜索作品、创作者、文章')"
              v-model="searchContent"
              @keyup.enter="searchSubmit"
            />
            <div class="sousuoIcon" @click="searchSubmit">
              <img src="/static/home/head_search_icon@2x.png" alt="" /><span>{{
                $t("global.搜索")
              }}</span>
            </div>
          </div>
          <div class="login" v-if="!login">
            <p>
              <router-link
                :to="`/login?redirecturl=${redirecturl}`"
                tag="span"
                >{{ $t("global.登录") }}</router-link
              >
              /
              <router-link to="/reg" tag="span">{{
                $t("global.注册")
              }}</router-link>
            </p>
          </div>
          <div
            class="submit"
            @mouseenter="isShow11 = true"
            @mouseleave="isShow11 = false"
          >
            <p class="title">
              <img src="/static/home/head_upload_btn@2x.png" alt="" />{{
                $t("global.发布")
              }}
            </p>
            <div class="down" v-show="isShow11">
              <router-link to="/UpVideo"
                ><img src="/static/home/publish_video@2x.png" alt="" />{{
                  $t("global.视频")
                }}</router-link
              >
              <router-link to="/article/edit"
                ><img src="/static/home/publish_article@2x.png" alt="" />{{
                  $t("global.文章")
                }}</router-link
              >
              <router-link to="/activity/all?type=1"
                ><img src="/static/home/publish_event@2x.png" alt="" />{{
                  $t("global.活动")
                }}</router-link
              >
            </div>
          </div>
          <div class="message" v-if="login" @click="gotoMess('/MessageCenter')">
            <img src="/static/home/notification_icon_hover@2x.png" alt="" />
            <span v-show="messageCount !== 0"></span>
          </div>
          <div
            class="avatar"
            v-if="login"
            @mouseenter="isShow12 = true"
            @mouseleave="isShow12 = false"
          >
            <router-link to="/manageCenter">
              <img
                :src="
                  peopleMessage &&
                  peopleMessage.avatar
                    | imageUrl('/static/profile_img_default.png', 72, 72)
                "
              />
            </router-link>

            <div class="down" v-show="isShow12">
              <div class="nameDiv">{{ peopleMessage.nickname }}</div>
              <div class="countDiv">
                <span @click="gotoPeople(1)"
                  >{{ $t("global.关注") }}<i>{{ followCount || 0 }}</i></span
                >
                ·
                <span @click="gotoPeople(2)"
                  >{{ $t("global.粉丝") }}<i>{{ fansCount || 0 }}</i></span
                >
              </div>
              <router-link
                target="_blank"
                :to="`/peopleCenter/${peopleMessage.userId}`"
                class="myHome"
                >{{ $t("global.我的主页") }}</router-link
              >
              <div class="peopleHome">
                <router-link to="/manageVideo" target="_blank">{{
                  $t("global.个人中心")
                }}</router-link>
                <router-link to="/manageVideo">{{
                  $t("global.视频管理")
                }}</router-link>
                <router-link to="/MyCollect">{{
                  $t("global.我的收藏")
                }}</router-link>
                <router-link to="/MyCompetition">{{
                    $t("global.我的竞赛")
                  }}</router-link>
                <router-link to="/MyRecruit" v-if="isAuthentication">{{
                    $t("recruit.招聘管理")
                  }}</router-link>
                  <router-link to="/jobWanted" v-else>求职管理</router-link>
              </div>
              <div class="accountHome">
                <router-link to="/manageCenter">{{
                  $t("global.账户设置")
                }}</router-link>
                <p @click="loginout">{{ $t("global.退出登录") }}</p>
              </div>
            </div>
          </div>
          <div
            class="language"
            @mouseenter="isShow13 = true"
            @mouseleave="isShow13 = false"
          >
            <p class="title">
              <img src="/static/home/lang_icon@2x.png" alt="" />{{
                showLanguage
              }}
            </p>
            <div class="down" v-show="isShow13">
              <p @click="changeLanguage('中文')">中文</p>
              <p @click="changeLanguage('English')">English</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["type"],
  data() {
    return {
      login: "",
      searchContent: "",
      messageCount: 0,
      isHeadBackTop: false,
      showSearch: false,
      isActive: null,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
      isShow7: false,
      isShow8: false,
      isShow9: false,
      isShow10: false,
      isShow11: false,
      isShow12: false,
      isShow13: false,
      isShow14: false,
      isHeaderShow: false,
      followCount: null,
      fansCount: null,
      homeType: true,
      leftOffset: 0,
      isAuthentication: false
    };
  },
  created() {
    if (this.$route.path) {
      if (this.$route.path == "/") {
        this.isActive = 1;
        this.homeType = false;
      }
      if (this.$route.path == "/activity/match") {
        this.isActive = 2;
      }
      if (this.$route.path == "/live/list") {
        this.isActive = 3;
      }
      if (this.$route.path == "/channel/1") {
        this.isActive = 4;
      }
      if (this.$route.path == "/activity/all"||this.$route.path == "/activity/online"||this.$route.path == "/activity/offline") {
        this.isActive = 5;
      }
      if (this.$route.path == "/jobs/home") {
          this.isActive = 6;
      }
    }
    this.getInfo();
    this.getMessage();
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    showLanguage() {
      if (location.hash) {
        return location.hash === "#!en" ? "EN" : "中文";
      } else if (localStorage.getItem("language")) {
        return localStorage.getItem("language") === "#!en" ? "EN" : "中文";
      } else {
        return "中文";
      }
    },
    language() {
      return this.$language();
    },
    redirecturl() {
      return window.location.href.split("?")[0];
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    gotoPeople(type) {
      let routeData = this.$router.resolve({
        path:
          "/peopleCenter/" + this.peopleMessage.userId + "/home?type=" + type,
      });
      window.open(routeData.href, "_blank");
    },
    handleScroll() {
      var scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.leftOffset = document.documentElement.scrollLeft || document.body.scrollLeft;
      if (scroll > 66) {
        this.isHeaderShow = true;
      } else {
        this.isHeaderShow = false;
      }
    },
    gotoRouter(router) {
      this.$router.push(router);
    },
    changeLanguage(language) {
      if (this.login) {
        this.$http.post("/api/u/changeLanguage").then((res) => {
          switch (language) {
            case "中文":
              location.hash = "#!zh";
              break;
            case "English":
              location.hash = "#!en";
              break;
          }
          location.reload();
        });
      } else {
        switch (language) {
          case "中文":
            location.hash = "#!zh";
            break;
          case "English":
            location.hash = "#!en";
            break;
        }
        location.reload();
      }
    },
    handingScroll() {
      let scrollY = document.getElementById("developcontainer").scrollTop;
      if (scrollY > 100) {
        this.isHeadBackTop = true;
      } else if (scrollY == 0) {
        this.isHeadBackTop = false;
      }
    },

    goto(path) {
      if (path === "/login") {
        path += `?redirecturl=${window.location}`;
      }
      this.$router.push(path);
    },
    gotoMess(path) {
      this.messageCount = 0;
      this.$router.push(path);
    },
    searchSubmit() {
      // if (this.searchContent === "") {
      //   this.$message({
      //     showClose: true,
      //     message: this.$t("global.请输入搜索内容")
      //   });
      // } else {
      //   var par = this.searchContent.replace("/", "%2F");
      //   par=par.replace("#","%23");
      //   this.$router.push("/Search/" + par + "/" + this.pageType + "/normal");
      // }
      if (!this.searchContent.replace(/[\r\n\s]/g, "")) {
        this.$message({
          showClose: true,
          message: this.$t("global.请输入搜索内容"),
        });
        return;
      }
      // this.$router.push("/Search/"+ this.searchContent);
      this.$router.push({
        path: "/Search",
        query: { content: this.searchContent },
      });
    },
    loginout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      this.login = false;
      if (location.pathname === "/manageCenter") {
        location.assign(`${location.origin}`);
      } else {
        location.reload();
      }
    },
    getInfo() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then((response) => {
          if (response.code !== "ServiceError") {
            this.$store.dispatch("setNewState", {
              peopleMessage: response.data,
              accountUser: response.data,
            });
            if (response.data.userType === 2 && response.data.isCertification === 1) {
              this.isAuthentication = true;
            } else {
              this.isAuthentication = false;
            }
            this.$http
              .get(
                "/api/mobile/u/getInfo?userId=" +
                  response.data.userId +
                  "&type=1"
              )
              .then((res) => {
                if (res.code === "OK") {
                  this.followCount = res.data.followCount;
                  this.fansCount = res.data.fansCount;
                }
              });
          } else {
            this.loginout();
          }
        });
      }
    },
    getMessage() {
      let auth_token = localStorage.getItem("auth_token");
      let isLogin = localStorage.getItem("isLogin");
      if (auth_token) {
        this.$http.get("/api/customer/count/unread").then((response) => {
          if (response.code == "Unauthorized") {
            this.login = false;
            return;
          }
          let data = response.data;
          this.messageCount = data;
        });
        if (isLogin == "true") {
          this.login = true;
        }
      }
    },
  },
  watch: {
    "$store.state.isLogin"(val) {
      if (val != null && val != "") {
        this.login = true;
      } else {
        this.login = false;
      }
    },
    $route() {
      if (this.$route.path) {
        if (this.$route.path == "/") {
          this.isActive = 1;
          this.homeType = false;
        }
        if (this.$route.path == "/activity/match") {
          this.isActive = 2;
        }
        if (this.$route.path == "/live/list") {
          this.isActive = 3;
        }
        if (this.$route.path == "/channel/1") {
          this.isActive = 4;
        }
        if (this.$route.path == "/activity/all"||this.$route.path == "/activity/online"||this.$route.path == "/activity/offline") {
          this.isActive = 5;
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.newHeader {
  width: 100%;
  height: 126px;
  background: #FFFFFF;
  border-bottom: 1px solid #ebebeb;
  min-width: 1344px;

  .headerBox {
    width: 1110px;
    margin: 0 auto;

    .headerLogo {
      width: 160px;
      height: 68px;
      float: left;
      margin-top: 28px;
      margin-right: 30px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .headerContent {
      float: left;
      margin-top: 16px;

      .headerTop {
        .sousuo {
          width: 635px;
          height: 40px;
          border: 2px solid #EBEBEB;
          float: left;

          input {
            float: left;
            width: 535px;
            height: 34px;
            line-height: 34px;
            border: none;
            padding-left: 16px;
          }

          .sousuoIcon {
            float: right;
            width: 78px;
            height: 40px;
            background: #EBEBEB;
            line-height: 40px;
            text-align: center;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
              margin-right: 1px;
              margin-bottom: 1px;
            }

            span {
              font-size: 14px;
              font-weight: 400;
              color: #333333;
            }
          }
        }

        .sousuoEn {
          width: 615px;

          input {
            width: 515px;
          }
        }

        .login {
          height: 40px;
          line-height: 40px;
          float: left;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          cursor: pointer;
          margin-left: 20px;
        }

        .submit {
          float: left;
          width: 84px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin-top: 2px;
          margin-left: 20px;
          cursor: pointer;
          position: relative;

          .title {
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            width: 84px;
            height: 36px;
            line-height: 36px;
            background: #2026CC;

            img {
              width: 18px;
              height: 18px;
              margin-right: 3px;
              margin-bottom: 2px;
            }
          }

          .down {
            padding: 10px 0;
            background: #FFFFFF;
            position: absolute;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            z-index: 11111;

            p, a {
              display: block;
              padding: 0 30px;
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 400;
              color: #0A0A0A;
              white-space: nowrap;

              img {
                width: 20px;
                height: 20px;
                margin-right: 9px;
                margin-bottom: 2px;
              }

              &:hover {
                background: #F5F5F5;
              }
            }
          }
        }

        .message {
          float: left;
          height: 40px;
          line-height: 40px;
          margin-left: 20px;
          position: relative;
          cursor: pointer;

          img {
            width: 18px;
            height: 18px;
          }

          span {
            position: absolute;
            width: 9px;
            height: 9px;
            background: #FE5630;
            top: 6px;
            right: -7px;
            border-radius: 50%;
          }
        }

        .avatar {
          float: left;
          margin-top: 2px;
          margin-left: 20px;
          width: 36px;
          height: 40px;
          cursor: pointer;
          position: relative;

          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
          }

          .down {
            width: 180px;
            padding: 10px 0;
            background: #FFFFFF;
            position: absolute;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            z-index: 11111;

            p, a {
              display: block;
              padding-left: 20px;
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 400;
              color: #0A0A0A;
              white-space: nowrap;

              img {
                width: 20px;
                height: 20px;
                margin-right: 2px;
                margin-bottom: 2px;
              }

              &:hover {
                background: #F5F5F5;
              }
            }

            .nameDiv {
              font-size: 15px;
              font-weight: 600;
              color: #0A0A0A;
              text-align: center;
              line-height: 23px;
            }

            .countDiv {
              line-height: 40px;
              text-align: center;

              span {
                font-size: 12px;
                font-weight: 400;
                color: #666666;

                i {
                  font-size: 13px;
                  font-weight: 400;
                  color: #333333;
                  margin-left: 4px;
                }
              }
            }

            .myHome {
              width: 80px;
              height: 26px;
              border: 1px solid #2026CC;
              margin: 0 auto;
              line-height: 26px;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
              color: #2026CC;
              padding: 0;
            }

            .peopleHome {
              margin-top: 16px;
              border-top: 1px solid rgba(235, 235, 235, 1);
              border-bottom: 1px solid rgba(235, 235, 235, 1);
              padding: 9px 0;
            }

            .accountHome {
              padding-top: 9px;
            }
          }
        }

        .language {
          float: left;
          height: 40px;
          line-height: 40px;
          margin-left: 20px;
          cursor: pointer;
          position: relative;

          .title {
            font-size: 14px;
            font-weight: 400;
            color: #333333;

            img {
              width: 18px;
              height: 18px;
              margin-right: 1px;
              margin-bottom: 3px;
            }
          }

          .down {
            padding: 10px 0;
            background: #FFFFFF;
            position: absolute;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            z-index: 11111;

            p, a {
              display: block;
              padding: 0 30px;
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 400;
              color: #0A0A0A;
              white-space: nowrap;

              &:hover {
                background: #F5F5F5;
              }
            }
          }
        }
      }

      .headerBottom {
        margin-top: 20px;

        .navUl {
          li {
            float: left;
            margin-right: 48px;
            height: 35px;
            cursor: pointer;
            position: relative;

            a {
              font-size: 18px;
              font-weight: 600;
              color: #0A0A0A;

              img {
                width: 9px;
                height: 9px;
                margin-left: 6px;
              }
            }

            p {
              font-size: 18px;
              font-weight: 600;
              color: #0A0A0A;

              img {
                width: 9px;
                height: 9px;
                margin-left: 6px;
              }
            }

            .appUpload {
              background: #FFFFFF;
              position: absolute;
              top: 35px;
              left: 50%;
              transform: translateX(-50%);
              box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
              border: 1px solid #EBEBEB;
              z-index: 11111;
              width: 125px;
              height: 125px;

              img {
                width: 105px;
                height: 105px;
                margin-top: 10px;
                margin-left: 10px;
              }
            }

            .down {
              padding: 10px 0;
              background: #FFFFFF;
              position: absolute;
              top: 35px;
              left: 50%;
              transform: translateX(-50%);
              box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
              border: 1px solid #EBEBEB;
              z-index: 11111;

              a {
                display: block;
                padding: 0 30px;
                height: 34px;
                line-height: 34px;
                font-size: 14px;
                font-weight: 400;
                color: #0A0A0A;
                white-space: nowrap;

                &:hover {
                  background: #F5F5F5;
                }
              }
            }
          }

          li.active {
            border-bottom: 3px solid #2026CC;

            a {
              color: #2026CC;
            }
          }
        }

        .navUlEn {
          li {
            margin-right: 24px;
          }
        }
      }
    }
  }
}

.newHeader1 {
  height: 66px;
  border-bottom: none;
}

.headerFixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  background: #fff;
  width: 100%;
  min-width: 1344px;
  height: 66px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);

  .box {
    width: 1344px;
    height: 66px;
    line-height: 66px;
    margin: 0 auto;

    .headerLogo {
      float: left;
      width: 120px;
      height: 50px;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .headerBottom {
      float: left;

      .navUl {
        li {
          float: left;
          margin-right: 36px;
          height: 35px;
          cursor: pointer;
          position: relative;

          a {
            font-size: 15px;
            font-weight: 400;
            color: #0A0A0A;

            img {
              width: 9px;
              height: 9px;
              margin-left: 6px;
            }
          }

          p {
            font-size: 15px;
            font-weight: 400;
            color: #0A0A0A;

            img {
              width: 9px;
              height: 9px;
              margin-left: 6px;
            }
          }

          .appUpload {
            background: #FFFFFF;
            position: absolute;
            top: 50px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            z-index: 11111;
            width: 125px;
            height: 125px;

            img {
              width: 105px;
              height: 105px;
              margin-top: 10px;
              margin-left: 10px;
            }
          }

          .down {
            padding: 10px 0;
            background: #FFFFFF;
            position: absolute;
            top: 50px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            z-index: 11111;

            a {
              display: block;
              padding: 0 30px;
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 400;
              color: #0A0A0A;
              white-space: nowrap;

              &:hover {
                background: #F5F5F5;
              }
            }
          }
        }

        li.active {
          a {
            color: #2026CC;
          }
        }
      }

      .navUlEn {
        li {
          margin-right: 22px;
        }
      }
    }

    .sousuo {
      float: left;
      width: 255px;
      height: 40px;
      border: 2px solid #EBEBEB;
      float: left;
      margin-top: 15px;

      input {
        float: left;
        width: 155px;
        height: 34px;
        line-height: 34px;
        border: none;
        padding-left: 16px;
      }

      .sousuoIcon {
        float: right;
        width: 78px;
        height: 40px;
        background: #EBEBEB;
        line-height: 40px;
        text-align: center;
        cursor: pointer;

        img {
          width: 18px;
          height: 18px;
          margin-right: 1px;
          margin-bottom: 1px;
        }

        span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
      }
    }

    .sousuoEn {
      width: 198px;

      input {
        width: 98px;
      }
    }

    .login {
      height: 40px;
      line-height: 40px;
      float: left;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      margin-left: 20px;
      margin-top: 15px;
    }

    .submit {
      float: left;
      width: 84px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin-top: 17px;
      margin-left: 20px;
      cursor: pointer;
      position: relative;

      .title {
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        width: 84px;
        height: 36px;
        line-height: 36px;
        background: #2026CC;

        img {
          width: 18px;
          height: 18px;
          margin-right: 3px;
          margin-bottom: 2px;
        }
      }

      .down {
        padding: 10px 0;
        background: #FFFFFF;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
        border: 1px solid #EBEBEB;
        z-index: 11111;

        p, a {
          display: block;
          padding: 0 30px;
          height: 34px;
          line-height: 34px;
          font-size: 14px;
          font-weight: 400;
          color: #0A0A0A;
          white-space: nowrap;

          img {
            width: 20px;
            height: 20px;
            margin-right: 9px;
            margin-bottom: 2px;
          }

          &:hover {
            background: #F5F5F5;
          }
        }
      }
    }

    .message {
      float: left;
      height: 40px;
      line-height: 40px;
      margin-left: 20px;
      position: relative;
      cursor: pointer;
      margin-top: 14px;

      img {
        width: 18px;
        height: 18px;
      }

      span {
        position: absolute;
        width: 9px;
        height: 9px;
        background: #FE5630;
        top: 6px;
        right: -7px;
        border-radius: 50%;
      }
    }

    .avatar {
      float: left;
      margin-left: 20px;
      width: 36px;
      height: 66px;
      line-height: 66px;
      cursor: pointer;
      position: relative;

      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }

      .down {
        width: 180px;
        padding: 10px 0;
        background: #FFFFFF;
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
        border: 1px solid #EBEBEB;
        z-index: 11111;

        p, a {
          display: block;
          padding-left: 20px;
          height: 34px;
          line-height: 34px;
          font-size: 14px;
          font-weight: 400;
          color: #0A0A0A;
          white-space: nowrap;

          img {
            width: 20px;
            height: 20px;
            margin-right: 2px;
            margin-bottom: 2px;
          }

          &:hover {
            background: #F5F5F5;
          }
        }

        .nameDiv {
          font-size: 15px;
          font-weight: 600;
          color: #0A0A0A;
          text-align: center;
          line-height: 23px;
        }

        .countDiv {
          line-height: 40px;
          text-align: center;

          span {
            font-size: 12px;
            font-weight: 400;
            color: #666666;

            i {
              font-size: 13px;
              font-weight: 400;
              color: #333333;
              margin-left: 4px;
            }
          }
        }

        .myHome {
          width: 80px;
          height: 26px;
          border: 1px solid #2026CC;
          margin: 0 auto;
          line-height: 26px;
          text-align: center;
          font-size: 14px;
          font-weight: 600;
          color: #2026CC;
          padding: 0;
        }

        .peopleHome {
          margin-top: 16px;
          border-top: 1px solid rgba(235, 235, 235, 1);
          border-bottom: 1px solid rgba(235, 235, 235, 1);
          padding: 9px 0;
        }

        .accountHome {
          padding-top: 9px;
        }
      }
    }

    .language {
      float: left;
      height: 40px;
      line-height: 40px;
      margin-left: 20px;
      cursor: pointer;
      position: relative;
      margin-top: 15px;

      .title {
        font-size: 14px;
        font-weight: 400;
        color: #333333;

        img {
          width: 18px;
          height: 18px;
          margin-right: 1px;
          margin-bottom: 3px;
        }
      }

      .down {
        padding: 10px 0;
        background: #FFFFFF;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
        border: 1px solid #EBEBEB;
        z-index: 11111;

        p, a {
          display: block;
          padding: 0 30px;
          height: 34px;
          line-height: 34px;
          font-size: 14px;
          font-weight: 400;
          color: #0A0A0A;
          white-space: nowrap;

          &:hover {
            background: #F5F5F5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/Header.vue